import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import classList from 'flarum/common/utils/classList';
import Button from 'flarum/common/components/Button';
function toPoll(data) {
  if (data) {
    const poll = app.store.createRecord('polls');
    poll.tempOptions = data.options.map(option => {
      const pollOption = app.store.createRecord('poll_options');
      pollOption.pushAttributes(option);
      return pollOption;
    });
    poll.pushAttributes(data);
    return poll;
  }
  return data;
}
function addPoll(composer) {
  app.modal.show(() => import(/* webpackChunkName: 'forum/components/CreatePollModal', webpackMode: 'lazy-once' */ './components/CreatePollModal'), {
    poll: toPoll(composer.composer.fields.poll),
    onsubmit: poll => composer.composer.fields.poll = poll
  });
}
export const addToComposer = composerPath => {
  extend(composerPath, 'headerItems', function (items) {
    const discussion = this.composer.body?.attrs?.discussion;
    const canStartPoll = discussion?.canStartPoll() ?? app.forum.attribute('canStartPolls');
    if (canStartPoll) {
      items.add('polls', m(Button, {
        className: "ComposerBody-poll Button Button--ua-reset",
        onclick: () => addPoll(this)
      }, m("span", {
        className: classList('PollLabel', !this.composer.fields.poll && 'none')
      }, app.translator.trans(`fof-polls.forum.composer_discussion.${this.composer.fields.poll ? 'edit' : 'add'}_poll`))), 1);
    }
  });
  extend(composerPath, 'data', function (data) {
    if (this.composer.fields.poll) {
      data.poll = this.composer.fields.poll;
    }
  });
};

// Core's fallback focuses the first `:input` in the composer, which is the poll
// button in the reply header. Left alone if core (or another extension) sets one.
export const focusEditorOnOpen = composerBody => {
  composerBody.focusOnSelector ??= () => '.TextEditor-editor';
};
export default () => {
  addToComposer('flarum/forum/components/DiscussionComposer');
  addToComposer('flarum/forum/components/ReplyComposer');
  flarum.reg.onLoad('core', 'forum/components/ReplyComposer', focusEditorOnOpen);
};flarum.reg.addChunkModule('966', '9859', 'fof-polls', 'forum/components/CreatePollModal');
flarum.reg.addChunkModule('966', '9859', 'fof-polls', 'forum/components/Poll/PollForm');
flarum.reg.addChunkModule('966', '9859', 'fof-polls', 'forum/components/UploadPollImageButton');
flarum.reg.addChunkModule('966', '9859', 'fof-polls', 'forum/components/SchedulePollModal');
flarum.reg.addChunkModule('966', '9859', 'fof-polls', 'forum/components/form/FormError');
flarum.reg.addChunkModule('966', '9859', 'fof-polls', 'forum/states/AbstractPollListState');
flarum.reg.addChunkModule('966', '9859', 'fof-polls', 'forum/states/PollFormState');
flarum.reg.addChunkModule('966', '9859', 'fof-polls', 'forum/states/PollListState');
flarum.reg.addChunkModule('966', '9859', 'fof-polls', 'forum/utils/PollControls');